import { gql } from '@apollo/client'

// Fila de "próximo aprendizado" do curso (HET-4236): os produtos que o produtor oferta na sidebar
// da aula, em ordem. O card mostra o primeiro que o aluno ainda não tem.
export const GET_COURSE_NEXT_LEARNING = gql`
  query CourseNextLearning($courseId: ID!) {
    membersConfig(version: "production") {
      id
      customProductLists(courseId: $courseId) {
        id
        items(pagination: { limit: 20, offset: 0 }) {
          id
          kind
          order
          activeForUser
          schoolProductId
          enrollmentId
          customPageUrl
          title
          logo
          logoVertical
          offerId
          paymentMethods
        }
      }
    }
  }
`
